import { useState, useEffect } from "react";
import { T } from "../data/Tokens";
import { apiFetch } from "../../api/api";

export default function PhotobookOrdersAdmin() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchOrders = () => {
    setLoading(true);
    apiFetch("/photobook/orders-list.php")
      .then(data => setOrders(data.data || []))
      .catch(err => setError(err.message || "Failed to load orders"))
      .finally(() => setLoading(false));
  };
  useEffect(() => { fetchOrders(); }, []);

  const updateStatus = async (id, status) => {
    setOrders(prev => prev.map(o => o.id === id ? { ...o, status } : o));
    try {
      await apiFetch("/photobook/orders-update-status.php", { method: "PUT", body: { id, status } });
    } catch (err) {
      alert(err.message || "Status update fail ho gaya.");
      fetchOrders();
    }
  };

  const deleteOrder = async (id) => {
    if (!window.confirm("Is order ko delete karna hai? Ye undo nahi ho sakta.")) return;
    const prev = orders;
    setOrders(o => o.filter(x => x.id !== id));
    try {
      await apiFetch("/photobook/orders-delete.php", { method: "DELETE", body: { id } });
    } catch (err) {
      alert(err.message || "Delete fail ho gaya.");
      setOrders(prev);
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <div>
        <h1 className="text-[18px] sm:text-[24px] font-bold" style={{ color: T.textPri, fontFamily: T.serif }}>Photobook Orders</h1>
        <p className="text-[11px] sm:text-[12px]" style={{ color: T.textSec }}>{orders.length} orders</p>
      </div>

      {error && <div className="rounded-xl p-3 text-[12px]" style={{ background: "#fee", color: T.danger }}>{error} — <button onClick={fetchOrders} className="underline">retry</button></div>}

      {loading ? (
        <div className="flex items-center justify-center py-16">
          <div style={{ width: 24, height: 24, border: "3px solid rgba(200,164,106,0.3)", borderTopColor: T.gold, borderRadius: "50%", animation: "pbspin3 0.7s linear infinite" }} />
          <style>{`@keyframes pbspin3{to{transform:rotate(360deg)}}`}</style>
        </div>
      ) : orders.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 rounded-2xl" style={{ background: "#fff", border: `1px solid ${T.border}` }}>
          <div className="text-4xl mb-3">📄</div>
          <p className="text-[14px] font-semibold" style={{ color: T.textPri }}>Koi order nahi hai abhi</p>
        </div>
      ) : (
        <div className="rounded-2xl overflow-hidden bg-white overflow-x-auto" style={{ border: `1px solid ${T.border}` }}>
          <table className="w-full text-[12px]">
            <thead>
              <tr style={{ background: T.bgSoft }}>
                <th className="text-left px-3 py-2 whitespace-nowrap">Order</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">Product</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">Size</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">Pages</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">Customer</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">Date</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">Status</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">PDF</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(o => (
                <tr key={o.id} style={{ borderTop: `1px solid ${T.border}` }}>
                  <td className="px-3 py-2 font-semibold whitespace-nowrap">{o.order_ref}</td>
                  <td className="px-3 py-2">{o.product_name}{o.project_name ? ` — ${o.project_name}` : ""}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{o.size || "—"}</td>
                  <td className="px-3 py-2">{o.pages_count}</td>
                  <td className="px-3 py-2">{o.customer_name || o.customer_email || "—"}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{new Date(o.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</td>
                  <td className="px-3 py-2">
                    <select value={o.status} onChange={e => updateStatus(o.id, e.target.value)}
                      className="border rounded-lg px-2 py-1 text-[11px] outline-none" style={{ borderColor: T.border }}>
                      <option>Pending</option>
                      <option>Printed</option>
                      <option>Shipped</option>
                      <option>Delivered</option>
                    </select>
                  </td>
                  <td className="px-3 py-2">
                    <a href={o.pdf_url} target="_blank" rel="noreferrer"
                      className="px-2 py-1 rounded-lg text-[11px] font-semibold border inline-block whitespace-nowrap" style={{ borderColor: T.gold, color: T.gold }}>
                      ⬇ Download
                    </a>
                  </td>
                  <td className="px-3 py-2">
                    <button onClick={() => deleteOrder(o.id)}
                      className="px-2 py-1 rounded-lg text-[11px] font-semibold border inline-block whitespace-nowrap"
                      style={{ borderColor: T.danger, color: T.danger }}>
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

